import SEO from "../../../components/seo.jsx"
import { useRef, useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ── Swap these asset imports per page ──
import HeroImg       from "../../../assets/eyelash-hero.png";
import BreadcrumbImg from "../../../assets/eyelash-breadcrumb-bg.jpg";  
import SurgeonImg    from "../../../assets/team/Dr-idris.jpeg";
import ProcedureImg  from "../../../assets/eyelash-procedure.jpg";  
import HowEyelash    from "../../../assets/howEyelash.jpg"      
import ResultImg     from "../../../assets/eyelash-result.jpg";         

gsap.registerPlugin(ScrollTrigger);
const cinzel = { fontFamily: "'Cinzel', serif" };

const PAGE = {
  hero: {
    eyebrow: "Facial Hair Restoration",
    heading: "Eyelash Hair Transplant",
    sub: "Fuller, natural-looking lashes restored with precision at Clinique Internationale, India.",
  },

  breadcrumb: [
    { label: "Home", href: "/" },
    { label: "Eyelash Hair Transplant", href: null },
  ],

  /* ── INTRO ── */
  intro: {
    eyebrow: "Overview",
    heading: "Eyelash Hair Transplant in India",
    paragraphs: [
      "Eyelash hair transplant involves harvesting hair follicles from a donor area (often the back of the head) and implanting them into the eyelid to enhance lash density. This meticulous procedure, done under local anaesthesia, aims to restore or augment lashes for cosmetic purposes addressing thinning or absent lashes due to injury, genetics, or medical conditions.",
      "Precision is crucial to ensure natural-looking results and minimise potential risks like irritation or misdirection of the transplanted hairs.",
      "Clinique Internationale offers cutting-edge eyelash hair transplant procedures in India for those seeking fuller, natural-looking lashes. With a team of skilled surgeons and state-of-the-art facilities, the clinic specialises in precise Follicular Unit Extraction (FUE) techniques, ensuring minimal scarring and optimal results. Patients receive personalised consultations to tailor the procedure to their specific needs and desired outcomes.",
    ],
  },

  /* ── SURGEON ── */
  surgeon: {
    eyebrow: "Lead Surgeon",
    heading: "Best Eyelash Hair Transplant Surgeon in India",
    paragraphs: [
      "Dr. Idris is a highly esteemed surgeon in India, specialising in eyelash hair transplant procedures. Renowned for his expertise and dedication, Dr. Idris has garnered recognition for his precise surgical skills and compassionate patient care. With extensive experience in the field, he has established himself as a leading figure in eyelash transplantation, offering advanced techniques and personalised treatment plans.",
      "Patients consistently praise Dr. Idris for his professionalism, attention to detail, and commitment to achieving natural-looking results. His proficiency in performing delicate procedures and his comprehensive understanding of facial aesthetics have earned him trust and admiration in the medical community.",
      "Dr. Idris's practice reflects his passion for enhancing the confidence and well-being of his patients through innovative and safe surgical interventions, making him a sought-after choice for those seeking quality care in eyelash hair transplantation in India.",
    ],
    tags: [ "Advanced Fellowship – Cosmetic Surgery", "AOMSI", "15+ Yrs Experience", "10,000+ Cases"],
  },

  /* ── COST ── */
  cost: {
    eyebrow: "Pricing",
    heading: "How Much Does Eyelash Hair Transplant Cost in India?",
    paragraphs: [
      "The eyelash hair transplant cost in India at Clinique Internationale typically ranges from ₹30,000 to ₹60,000. However, the final price can vary based on factors such as the number of grafts needed, the complexity of the procedure, and the clinic's specific pricing structure.",
      "It's advisable to consult with the clinic directly for an accurate quote tailored to your individual needs and expectations.",
    ],
    cities: [
  { city: "Pune",      range: "₹28,000 – ₹55,000", href: "https://pune.hairclinique.in/",  surgeon: "Dr. Ajinkya Patil" },
  { city: "Bangalore", range: "₹30,000 – ₹58,000", href: "/", surgeon: "Dr. Idris"         },
  { city: "Mumbai",    range: "₹32,000 – ₹60,000", href: "https://hairclinique.in/",       surgeon: "Dr. Bhavesh Gupta" },
  { city: "Shirdi",    range: "₹35,000 – ₹1,50,000", href: "https://shirdi.hairclinique.in/", surgeon: "Dr. Pranay Thakur" },
],
  },

  /* ── CENTRES ── */
  centres: {
    eyebrow: "Our Locations",
    heading: "Eyelash Hair Transplant Services Across India",
    intro: "We offer premier eyelash hair transplant services across Pune, Bangalore, and Mumbai. Our expert team ensures meticulous care and natural results transforming your lashes at convenient locations in these vibrant Indian cities.",
    items: [
      {
        num: "01",
        city: "Pune",
        title: "Best Eyelash Hair Transplant in Pune",
        surgeon: "Dr. Ajinkya Patil",
        href: "/dr-ajinkya-patil-pune",
        desc: "Dr. Ajinkya Patil excels in eyelash hair transplants at Clinique Internationale, Pune known for precision and natural-looking results. With expertise in the field, Dr. Patil's practice offers advanced techniques tailored to individual needs, ensuring optimal outcomes for patients seeking eyelash restoration. His dedication to aesthetic excellence and patient care has earned him a strong reputation in Pune's medical community.",
      },
      {
        num: "02",
        city: "Bangalore",
        title: "Best Eyelash Hair Transplant in Bangalore",
        surgeon: "Dr. Idris",
        href: "/Dr-Idris",
        desc: "Dr. Idris is a skilled eyelash hair transplant surgeon in Bangalore. With expertise in precision and aesthetic enhancement, he specialises in restoring and enhancing eyelash growth. His meticulous approach and commitment to patient satisfaction make him a sought-after professional in the field, providing top-tier care and natural-looking results for individuals seeking eyelash hair transplantation.",
      },
      {
        num: "03",
        city: "Mumbai",
        title: "Best Eyelash Hair Transplant in Mumbai",
        surgeon: "Dr. Bhavesh Gupta",
        href: "/dr-bhavesh-gupta",
        desc: "Eyelashes symbolise allure and expressiveness. Understanding this, Dr. Bhavesh Gupta leads our team in Mumbai, armed with extensive expertise and a passion for perfection. Clinique Internationale employs cutting-edge FUE techniques, ensuring precision and minimal scarring. The result is a natural, seamless outcome that enhances the eyes beautifully and permanently.",
      },
    ],
  },

  /* ── PROCEDURE STEPS ── */
  procedure: {
    eyebrow: "The Procedure",
    heading: "How is Eyelash Hair Transplant Performed?",
    intro: "An eyelash hair transplant is a meticulous procedure performed to enhance the appearance of eyelashes. It is typically conducted under local anaesthesia and involves the following steps:",
    steps: [
      {
        num: "01",
        title: "Donor Hair Extraction",
        desc: "Hair follicles are extracted from a donor site usually the back of the scalp where hair tends to be thicker and similar in texture to eyelashes.",
      },
      {
        num: "02",
        title: "Preparation of Hair Follicles",
        desc: "The extracted hair follicles are carefully dissected under a microscope to isolate individual follicular units containing 1–3 hairs each. Precision is crucial to ensure natural-looking results.",
      },
      {
        num: "03",
        title: "Tiny Incisions",
        desc: "Small, precise incisions are made along the eyelid's lash line where new eyelashes will be implanted. The angle, depth, and direction of these incisions are critical for the hairs to grow naturally.",
      },
      {
        num: "04",
        title: "Implantation",
        desc: "Each hair follicle is delicately placed into the incisions on the eyelid using specialised instruments. The surgeon ensures proper alignment and spacing to mimic natural eyelash growth.",
      },
      {
        num: "05",
        title: "Post-Procedure Care",
        desc: "After the transplant, patients receive specific instructions for post-operative care, which may include applying antibiotic ointment and avoiding certain activities to protect the newly transplanted hairs.",
      },
      {
        num: "06",
        title: "Healing and Growth",
        desc: "Over several weeks, the transplanted hair follicles shed initially, but new growth typically begins within a few months. Full results including thicker and longer eyelashes become more noticeable over time.",
      },
    ],
  },

  /* ── BENEFITS ── */
  benefits: {
    eyebrow: "Why It's Worth It",
    heading: "Benefits of Eyelash Hair Transplant",
    items: [
      { title: "Enhanced Eye Appearance",  desc: "Fuller, longer lashes naturally frame the eyes, enhancing overall facial expressiveness and drawing attention to your most captivating features." },
      { title: "Permanent Solution",       desc: "Transplanted hair follicles continue to grow naturally, providing a long-term, permanent improvement in lash density and appearance." },
      { title: "Natural Results",          desc: "FUE technique ensures follicles are placed at the correct angle and direction, resulting in completely natural-looking lashes indistinguishable from your own." },
      { title: "Minimal Downtime",         desc: "Most patients return to routine activities within a few days. Recovery is quick with proper post-op care and the clinic's aftercare guidance." },
      { title: "Boosts Confidence",        desc: "For those who have lost lashes due to conditions, trauma, or genetics, restored eyelashes significantly improve self-confidence and well-being." },
    ],
  },

  /* ── FAQs ── */
  faqs: [
    {
      q: "Where can I get the best treatment for eyelash transplant?",
      a: "For advanced and reliable eyelash transplants, Clinique Internationale in Mumbai is a top choice. The clinic uses modern FUE techniques, ensuring precision, natural lash growth, and long-lasting results with a patient-focused approach.",
    },
    {
      q: "Who is a good candidate for an eyelash transplant?",
      a: "Ideal candidates are individuals with naturally thin lashes or those who have lost eyelashes due to genetics, trauma, burns, over-plucking, or medical conditions. It is also suitable for anyone seeking fuller or longer lashes.",
    },
    {
      q: "How is the procedure performed?",
      a: "At Clinique Internationale, the eyelash transplant is typically done using the FUE technique. Individual hair follicles are carefully placed along the eyelid margin to create a natural-looking lash line that enhances the eyes.",
    },
    {
      q: "Is the procedure painful?",
      a: "The procedure is performed under local anaesthesia, minimising discomfort. Some mild swelling, redness, or soreness may occur for a few days but usually resolves quickly with proper care.",
    },
    {
      q: "How long does it take to see results?",
      a: "Initial eyelash growth starts in 2–3 months. Full results with natural, dense eyelashes are typically visible within 6–9 months.",
    },
  ],

  /* ── CTA ── */
  cta: {
    eyebrow: "Take the First Step",
    heading: "Ready for Fuller, More Expressive Lashes?",
    sub: "Book a personalised consultation with Dr. Idris at Clinique Internationale and take the first step toward natural, lasting eyelash restoration.",
    primary:   { label: "Book Consultation", href: "https://api.whatsapp.com/send?phone=919082123009&text=I%27m%20interested%20in%20Eyelash%20Hair%20Transplant" },
    secondary: { label: "View All Treatments", href: "/treatments" },
  },
};

/* ============================================================
   REUSABLE SUB-COMPONENTS  (identical across all treatment pages)
============================================================ */
function Eyebrow({ children, light = false, align = "left" }) {
  return (
    <p style={cinzel} className={`text-[10.5px] tracking-[0.28em] uppercase mb-3 flex items-center gap-2.5 ${align === "center" ? "justify-center" : "justify-start"} ${light ? "text-[#c9a84c]/70" : "text-[#a07828]"}`}>
      <span className={`w-6 h-px ${light ? "bg-[#c9a84c]/50" : "bg-[#c9a84c]"}`} />
      {children}
    </p>
  );
}

function SectionHeading({ children, light = false, align = "left" }) {
  return (
    <h2 style={cinzel} className={`font-black text-[1.3rem] sm:text-[1.6rem] md:text-[1.85rem] uppercase tracking-[0.05em] mb-8 leading-tight ${align === "center" ? "text-center" : "text-left"} ${light ? "text-white" : "text-[#1a0f02]"}`}>
      {children}
    </h2>
  );
}

function GoldDivider() {
  return <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/30 to-transparent" />;
}

function FramedImage({ src, alt, className = "" }) {
  return (
    <div className={`relative rounded-2xl overflow-hidden border border-[#c9a84c]/25 ${className}`}>
      <img src={src} alt={alt} className="w-full h-full object-cover" />
      <span className="absolute inset-0 ring-1 ring-inset ring-[#c9a84c]/15 rounded-2xl pointer-events-none" />
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${open ? "border-[#c9a84c]/40 bg-[#c9a84c]/[0.04]" : "border-[#c9a84c]/15 bg-white"}`}>
      <button className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-left" onClick={() => setOpen(p => !p)}>
        <span style={cinzel} className="text-[13px] font-bold tracking-[0.04em] text-[#1a0f02]">{q}</span>
        <span className={`flex-shrink-0 w-7 h-7 rounded-full border border-[#c9a84c]/35 flex items-center justify-center transition-transform duration-300 ${open ? "rotate-45 bg-[#c9a84c] border-[#c9a84c]" : ""}`}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 2v8M2 6h8" stroke={open ? "#1a0f02" : "#c9a84c"} strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </span>
      </button>
      {open && <div className="px-5 sm:px-6 pb-5"><p className="text-[13.5px] leading-[1.8] text-[#6b5535]">{a}</p></div>}
    </div>
  );
}

/* ============================================================
   PAGE COMPONENT identical structure to BeardHairTransplant
   and EyebrowHairTransplant. Only PAGE data changes.
============================================================ */
export default function EyelashHairTransplant({ url = "https://bangalore.hairclinique.in/eyelash-hair-transplants.php" }) {
  const pageRef     = useRef(null);
  const heroEyeRef  = useRef(null);
  const heroHeadRef = useRef(null);
  const heroSubRef  = useRef(null);
  const secRefs     = useRef([]);
  const addSection  = (el) => el && !secRefs.current.includes(el) && secRefs.current.push(el);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";
      gsap.fromTo(heroEyeRef.current,  { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.7,  ease });
      gsap.fromTo(heroHeadRef.current, { opacity: 0, y: 26 }, { opacity: 1, y: 0, duration: 0.75, ease, delay: 0.1  });
      gsap.fromTo(heroSubRef.current,  { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: 0.7,  ease, delay: 0.18 });
      secRefs.current.forEach((el) => {
        if (!el) return;
        gsap.fromTo(el, { opacity: 0, y: 36 }, {
          opacity: 1, y: 0, duration: 0.75, ease,
          scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" },
        });
      });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  const wrap = "w-full px-5 sm:px-10 lg:px-16 xl:px-24";
  const sec  = "py-16 sm:py-20 md:py-24";

  return (
    <>
    <SEO
  title="Eyelash Hair Transplant in Bangalore | Clinique Internationale"
  description="Get natural, fuller lashes with expert eyelash hair transplant at Clinique Internationale, led by Dr. Idris. Book your consultation today."
  url={url}
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

      <div ref={pageRef} className="relative w-full bg-[#f2ece0] overflow-hidden mt-16 lg:mt-20" style={{ fontFamily: "'Raleway', sans-serif" }}>

  {/* ══════════════════════════════════════
      HERO
  ══════════════════════════════════════ */}
  <div className="relative w-full h-[200px] xs:h-[280px] sm:h-[340px] md:h-[700px] flex items-center justify-end overflow-hidden">
    <img className="absolute inset-0 w-full h-full object-cover object-[center_20%] md:object-center" src={HeroImg} alt={PAGE.hero.heading} />
    <div className="absolute inset-0" />
    <div className="absolute inset-0 opacity-40 pointer-events-none"
      style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\")" }}
    />
    <div className="relative z-10 text-right px-4 sm:px-10 md:px-16 max-w-[85%] sm:max-w-xl ml-auto mr-0">
      <p ref={heroEyeRef} style={cinzel} className="text-[8px] xs:text-[9px] sm:text-[10.5px] tracking-[0.2em] xs:tracking-[0.24em] sm:tracking-[0.32em] uppercase text-black mb-2 sm:mb-4 flex items-center justify-end gap-2 sm:gap-3">
        <span className="w-4 sm:w-7 h-px bg-black" />{PAGE.hero.eyebrow}<span className="w-4 sm:w-7 h-px bg-black" />
      </p>
      <h1 ref={heroHeadRef} style={cinzel} className="font-black text-[1.4rem] xs:text-[1.8rem] sm:text-[2.8rem] md:text-[3.4rem] tracking-[0.02em] sm:tracking-[0.04em] uppercase text-black mb-2 sm:mb-3 leading-[1.15] sm:leading-tight">
        {PAGE.hero.heading}
      </h1>
      <p ref={heroSubRef} className="text-[11px] xs:text-[12px] sm:text-[15px] text-black/70 leading-relaxed ml-auto">{PAGE.hero.sub}</p>
    </div>
  </div>

        {/* ── BREADCRUMB ── */}
        <div className="relative w-full overflow-hidden">
          <img className="absolute inset-0 w-full h-full object-cover" src={BreadcrumbImg} alt="" aria-hidden="true" />
          <div className="absolute inset-0 bg-[#0e0905]/88" />
          <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/25 to-transparent" />
          <div className={`relative ${wrap} py-3.5 flex flex-wrap items-center gap-2`}>
            {PAGE.breadcrumb.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                {i > 0 && <span className="text-[#c9a84c]/30 text-xs">›</span>}
                {b.href
                  ? <a href={b.href} style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]/60 hover:text-[#c9a84c] transition-colors">{b.label}</a>
                  : <span style={cinzel} className="text-[10px] tracking-widest uppercase text-[#c9a84c]">{b.label}</span>}
              </span>
            ))}
          </div>
        </div>

        {/* ══════════════════════════════════════
            INTRO
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
                  <div ref={addSection} className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
                    <FramedImage src={ProcedureImg} alt="Hair transplant procedure close-up" className="h-[260px] sm:h-[320px] md:h-[380px] order-last md:order-first" />
                    <div>
                      <Eyebrow>{PAGE.intro.eyebrow}</Eyebrow>
                      <SectionHeading>{PAGE.intro.heading}</SectionHeading>
                      {PAGE.intro.paragraphs.map((p, i) => (
                        <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] mb-4">
                          {p}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>

        {/* ══════════════════════════════════════
            SURGEON (dark band)
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection} className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
              <div>
                <Eyebrow light>{PAGE.surgeon.eyebrow}</Eyebrow>
                <SectionHeading light>{PAGE.surgeon.heading}</SectionHeading>
                {PAGE.surgeon.paragraphs.map((p, i) => (
                  <p key={i} className="text-[13.5px] leading-[1.9] text-white/60 mb-4">{p}</p>
                ))}
                <div className="flex flex-wrap gap-2 mt-5">
                  {PAGE.surgeon.tags.map(t => (
                    <span key={t} style={cinzel} className="text-[9.5px] tracking-[0.12em] uppercase text-[#c9a84c]/90 border border-[#c9a84c]/25 rounded px-3 py-1">{t}</span>
                  ))}
                </div>
              </div>
              <img src={SurgeonImg} alt="Dr. Idris, eyelash hair transplant surgeon" className="h-[260px] sm:h-[320px] md:h-[460px] rounded-2xl" />
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            COST + CITY CARDS
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow align="center">{PAGE.cost.eyebrow}</Eyebrow>
            <SectionHeading align="center">{PAGE.cost.heading}</SectionHeading>
            {PAGE.cost.paragraphs.map((p, i) => (
              <p key={i} className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-4">{p}</p>
            ))}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-4xl mx-auto mt-8">
              {PAGE.cost.cities.map((c, i) => (
                <a key={i} href={c.href}
                  className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 relative overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(90,60,10,0.1)] transition-all duration-300 block text-center group">
                  <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                  <div style={cinzel} className="text-[13px] font-bold tracking-[0.06em] uppercase text-[#1a0f02] mb-1 group-hover:text-[#a07828] transition-colors">{c.city}</div>
                  <div className="text-[11.5px] text-[#6b5535] mb-3">{c.surgeon}</div>
                  <div style={cinzel} className="font-black text-[1.05rem] leading-snug bg-gradient-to-br from-[#c9943a] via-[#ffe9a0] to-[#c9943a] bg-clip-text text-transparent">{c.range}</div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            CENTRES
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow align="center">{PAGE.centres.eyebrow}</Eyebrow>
              <SectionHeading align="center">{PAGE.centres.heading}</SectionHeading>
              <p className="text-[14.5px] leading-[1.9] text-[#3a2e1e] max-w-3xl mx-auto text-center mb-10">{PAGE.centres.intro}</p>
              <div className="flex flex-col gap-5 max-w-4xl mx-auto">
                {PAGE.centres.items.map((c) => (
                  <div key={c.num} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-6 sm:p-8 relative overflow-hidden hover:shadow-[0_8px_28px_rgba(90,60,10,0.08)] transition-shadow">
                    <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                    <div className="flex flex-col sm:flex-row sm:items-start gap-5">
                      <div className="flex-shrink-0 flex flex-col items-center gap-1.5">
                        <span style={cinzel} className="font-black text-[2rem] leading-none text-[#c9a84c]/25 select-none">{c.num}</span>
                        <span style={cinzel} className="text-[9.5px] tracking-[0.12em] uppercase text-[#c9a84c]/80 border border-[#c9a84c]/25 rounded px-2.5 py-0.5 whitespace-nowrap">{c.city}</span>
                      </div>
                      <div>
                        <a href={c.href} style={cinzel} className="text-[14px] font-bold tracking-[0.05em] uppercase text-[#1a0f02] hover:text-[#a07828] transition-colors block mb-1">{c.title}</a>
                        <p className="text-[12px] text-[#c9a84c]/80 mb-2.5 font-medium">{c.surgeon}</p>
                        <p className="text-[13.5px] leading-[1.85] text-[#6b5535]">{c.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            PROCEDURE STEPS (image + 2-col grid)
        ══════════════════════════════════════ */}
        <div className="bg-[#0e0905] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow light align="center">{PAGE.procedure.eyebrow}</Eyebrow>
              <SectionHeading light align="center">{PAGE.procedure.heading}</SectionHeading>
              <p className="text-[14px] leading-[1.9] text-white/55 max-w-3xl mx-auto text-center mb-10">{PAGE.procedure.intro}</p>
              <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.1fr] gap-10 items-start">
                <FramedImage src={HowEyelash} alt="Eyelash hair transplant procedure" className="h-[260px] sm:h-[340px] lg:h-full lg:sticky lg:top-24" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {PAGE.procedure.steps.map((s) => (
                    <div key={s.num} className="relative overflow-hidden bg-white/[0.04] border border-[#c9a84c]/15 rounded-2xl p-5 hover:bg-[#c9a84c]/[0.07] hover:border-[#c9a84c]/30 transition-colors">
                      <span className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/35 to-transparent" />
                      <div className="flex items-center gap-2.5 mb-2.5">
                        <span style={cinzel} className="font-black text-[1.3rem] leading-none text-[#c9a84c]/25 select-none flex-shrink-0">{s.num}</span>
                        <div style={cinzel} className="text-[11.5px] font-bold tracking-[0.05em] uppercase text-white/90">{s.title}</div>
                      </div>
                      <p className="text-[12.5px] leading-[1.75] text-white/55">{s.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <GoldDivider />

        {/* ══════════════════════════════════════
            BENEFITS (result image + benefit cards)
        ══════════════════════════════════════ */}
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection}>
            <Eyebrow align="center">{PAGE.benefits.eyebrow}</Eyebrow>
            <SectionHeading align="center">{PAGE.benefits.heading}</SectionHeading>
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.15fr] gap-10 items-center">
              <FramedImage src={ResultImg} alt="Natural eyelash transplant result" className="h-[260px] sm:h-[320px]" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {PAGE.benefits.items.map((b, i) => (
                  <div key={i} className="bg-white border border-[#c9a84c]/18 rounded-2xl p-5 relative overflow-hidden hover:-translate-y-1 hover:shadow-[0_8px_28px_rgba(90,60,10,0.08)] transition-all duration-300">
                    <span className="absolute top-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent" />
                    <div className="flex items-center gap-2.5 mb-2">
                      <span style={cinzel} className="text-[11px] font-black text-[#c9a84c]">{String(i + 1).padStart(2, "0")}</span>
                      <div style={cinzel} className="text-[11.5px] font-bold tracking-[0.05em] uppercase text-[#1a0f02]">{b.title}</div>
                    </div>
                    <p className="text-[12.5px] leading-[1.75] text-[#6b5535]">{b.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            FAQs
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className="bg-[#faf8f4] py-16 sm:py-20 md:py-24">
          <div className={wrap}>
            <div ref={addSection}>
              <Eyebrow align="center">Common Questions</Eyebrow>
              <SectionHeading align="center">Eyelash Transplant FAQ at Clinique Internationale</SectionHeading>
              <div className="max-w-3xl mx-auto flex flex-col gap-3">
                {PAGE.faqs.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
              </div>
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            CTA
        ══════════════════════════════════════ */}
        <GoldDivider />
        <div className={`${wrap} ${sec}`}>
          <div ref={addSection} className="max-w-xl mx-auto text-center">
            <Eyebrow align="center">{PAGE.cta.eyebrow}</Eyebrow>
            <h3 style={cinzel} className="font-black text-[1.3rem] sm:text-[1.65rem] md:text-[1.9rem] text-[#1a0f02] uppercase tracking-[0.06em] mb-3.5">{PAGE.cta.heading}</h3>
            <p className="text-[14px] text-[#6b5535] leading-[1.75] mb-8">{PAGE.cta.sub}</p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a href={PAGE.cta.primary.href} target="_blank" rel="noopener noreferrer"
                style={{ ...cinzel, backgroundImage: "linear-gradient(135deg,#c9943a,#ffe9a0,#c9943a)", backgroundSize: "200% 100%" }}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-3.5 rounded-md text-[#1a0f02] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(201,168,76,0.35)] transition-all inline-block">
                {PAGE.cta.primary.label}
              </a>
              <a href={PAGE.cta.secondary.href} style={cinzel}
                className="text-[11px] font-bold tracking-[0.16em] uppercase px-8 py-[13px] rounded-md bg-transparent border border-[#1a0f02]/35 text-[#1a0f02] hover:-translate-y-0.5 hover:border-[#c9a84c] hover:text-[#a07828] transition-all inline-block">
                {PAGE.cta.secondary.label}
              </a>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}